import React, { FC, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { UserAppTransaction } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities';
import { EligibleRoute, SecureRoute } from '../../../packages/iam/src/components';
import { AccountListProvider } from '../../../packages/account/src/contexts/AccountList/AccountListProvider';
import { EnhancedAliasProvider } from '../../../packages/account/src/contexts/Alias/AliasProvider';
import { AccountRouter } from './AccountRouter';

const AccountsPage = lazy(
  () => import(/* webpackChunkName: "AccountsPageComponent" */ '../../../packages/account/src/pages/AccountsPage'),
);

const AccountsRouter: FC<GenericObject> = ({ brandConfig }) => (
  <AccountListProvider>
    <EnhancedAliasProvider>
      <Routes>
        <Route
          path='/*'
          element={
            <SecureRoute requiredEntitlements={UserAppTransaction.DepositAccounts}>
              <EligibleRoute>
                <AccountsPage pageConfig={brandConfig.accountsPage} />
              </EligibleRoute>
            </SecureRoute>
          }
        />
        <Route
          path='/:accountId/*'
          element={
            <AccountRouter
              requiredEntitlements={[UserAppTransaction.DepositAccounts, UserAppTransaction.DepositAccountDetails]}
              logic={'AND'}
              brandConfig={brandConfig}
            />
          }
        />
      </Routes>
    </EnhancedAliasProvider>
  </AccountListProvider>
);

export { AccountsRouter };
